var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWizardV(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1019_",
    d: "M16.28,13c0-1.52-1.05-2.79-2.45-3.16V8.1c1.41-0.37,2.45-1.64,2.45-3.16s-1.05-2.79-2.45-3.16V0H12.2 v1.77C10.78,2.13,9.72,3.4,9.72,4.94s1.06,2.81,2.48,3.17v1.72c-1.42,0.36-2.48,1.64-2.48,3.17c0,1.53,1.06,2.81,2.48,3.17v1.68 c-1.42,0.36-2.48,1.64-2.48,3.17s1.06,2.81,2.48,3.17V26h1.62v-1.82c1.41-0.37,2.45-1.64,2.45-3.16s-1.05-2.79-2.45-3.16v-1.7 C15.23,15.79,16.28,14.52,16.28,13z M11.34,4.94c0-0.91,0.74-1.66,1.66-1.66s1.66,0.74,1.66,1.66S13.91,6.59,13,6.59 S11.34,5.85,11.34,4.94z M11.34,13c0-0.91,0.74-1.66,1.66-1.66s1.66,0.74,1.66,1.66s-0.74,1.65-1.66,1.65S11.34,13.91,11.34,13z  M14.66,21.02c0,0.91-0.74,1.66-1.66,1.66s-1.66-0.74-1.66-1.66s0.74-1.66,1.66-1.66S14.66,20.11,14.66,21.02z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWizardV);
export default __webpack_public_path__ + "static/media/WizardV.9d2d2603839eb77a854cab615fbe48bc.svg";
export { ForwardRef as ReactComponent };